import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { FileSummary } from "@apaq/orgkit-js";
import { Download } from "src/app/net/download";

@Component({
  selector: 'app-file-entry',
  template: `<sl-label size="small" *ngIf="file != null">
    <app-file-preview [file]="file">
      <sl-icon class="mr-2" name="file-image"></sl-icon>
      {{file.name}}
    </app-file-preview>
    <sl-icon class="ml-2" name="download" (click)="downloadFile(file)"></sl-icon>
    <sl-icon class="ml-2" name="trash" (click)="deleteFile(file)"></sl-icon>
  </sl-label>`
})
export class FileEntryComponent {

  @ViewChild('dropdown') dropdown?: ElementRef;
  @Input() file?: FileSummary;
  @Output() fileDelete = new EventEmitter<FileSummary>();


  isImage() {
    if(this.file == null) return false;
    const index = this.file.name.lastIndexOf('.');
    if(index < 0 || index >= this.file.name.length-1) {
      return false;
    }

    const suffix = this.file.name.substring(this.file.name.lastIndexOf('.') + 1).toLowerCase()
    return ['png', 'jpg', 'gif', 'jpeg', 'tif', 'bmp', 'apng', 'avif', 'webp', 'svg'].indexOf(suffix) >= 0;
  }

  async downloadFile(file: FileSummary) {
    Download.fromUrl(file.url, file.name);
  }

  async deleteFile(file: FileSummary) {
    if(await Stallion.confirm($localize`Are you sure you want to delete the file?`, 'danger')) {
      this.fileDelete.emit(file);
    }
  }

  onMouseOver() {
    if(this.isImage()) {
      this.dropdown?.nativeElement.show();
    }
  }

  onMouseOut() {
    this.dropdown?.nativeElement.hide();
  }
}